import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    projectLocationId: Yup.number().nullable(),
    area: Yup.string().nullable(),
    operation: Yup.string().nullable(),
    sampleMedia: Yup.string().nullable(),
    analyzedBy: Yup.string().nullable(),
    analyticalMethod: Yup.string().nullable(),
    calibrationMethod: Yup.string().nullable(),
    calibrationNumber: Yup.string().nullable(),
    lotNumber: Yup.string().nullable(),
    windDirection: Yup.string().nullable(),
    maxWindSpeed: Yup.string().nullable(),
    minWindSpeed: Yup.string().nullable(),
    humidity: Yup.string().nullable(),
    temperature: Yup.string().nullable()
});

